import { WheelOperationStage } from "@/core/api/generated/v1";

export class WheelOperationHelper {
  public static humanizeWheelOperationStage(stage?: WheelOperationStage) {
    switch (stage) {
      case WheelOperationStage.None: {
        return "None";
      }
      case WheelOperationStage.Draft: {
        return "Draft";
      }
      case WheelOperationStage.InProgress: {
        return "In progress";
      }
      case WheelOperationStage.Completed: {
        return "Completed";
      }
      default: {
        return "-";
      }
    }
  }
}
